import React, { useState } from "react";
import {
  IonButton,
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonLabel,
  IonRange,
} from "@ionic/react";
import { useIntl } from "react-intl";

const TextSizer = (props) => {
  const { hideModal, onChangeTextSize } = props;
  const [value, setValue] = useState(+localStorage.getItem("textSize") || 1);
  const intl = useIntl();
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>
            {intl.formatMessage({
              id: `app.mobile.textSizer`,
            })}
          </IonTitle>
          <IonButtons slot="start">
            <IonButton
              onClick={() => {
                onChangeTextSize(value);
                hideModal();
              }}
              size="default"
            >
              {intl.formatMessage({
                id: `app.mobile.actions.save`,
              })}
            </IonButton>
          </IonButtons>
          <IonButtons slot="end">
            <IonButton
              onClick={() => {
                hideModal();
              }}
              size="default"
            >
              {intl.formatMessage({
                id: `app.mobile.actions.cancel`,
              })}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div style={{ padding: "16px" }}>
          <IonLabel>
            {intl.formatMessage({
              id: "app.mobile.text_sizer_instractions",
            })}
          </IonLabel>
        </div>
        <IonRange
          min={0.8}
          max={1.3}
          step={0.1}
          snaps={true}
          value={value}
          onIonChange={(e) => setValue(+e.detail.value)}
        >
          <IonLabel slot="start">
            {intl.formatMessage({
              id: "app.mobile.text_sizer_small_text",
            })}
          </IonLabel>
          <IonLabel slot="end">
            {intl.formatMessage({
              id: "app.mobile.text_sizer_large_text",
            })}
          </IonLabel>
        </IonRange>
      </IonContent>
    </IonPage>
  );
};

export default TextSizer;
